'use strict';

import {dispatch} from 'od-modules/secure_store/store';
import {SET_SELECTED_PAYMENT_METHOD, SET_SHOPPING_CART} from 'od-modules/secure_store/actions';

var storeCreditCards = require('./payment_manager/store_credit_cards');
const handler3ds = require('../modules/3ds/index').default;
const logger = require('od-modules/utils/logger');

var onUserDataChanged = function() {
    var isUserDataFilled = Odigeo._.isObject(this.model.get('user'));
    if (isUserDataFilled) {
        this.model.set('defaultDataStorage', 'userAccount');
    }
    this.view.$cachedSelectors.cardSaverManager.toggleClass('localStorageEnabled', !isUserDataFilled);
};

const responseEvents = {
    'BOOKING_USER_INTERACTION_NEEDED': ':userInteractionNeeded',
    'BOOKING_PAYMENT_RETRY': ':bookingPaymentRetryLoaded',
    'BOOKING_REPRICING': ':bookingRepricingLoaded',
    'BOOKING_CONFIRMED': ':bookingConfirmedLoaded',
    'BOOKING_REJECTED': ':bookingConfirmedLoaded',
    'BOOKING_ERROR': ':bookingErrorLoaded',
    'BOOKING_PENDING': ':bookingConfirmedLoaded',
    'BOOKING_RETAINED': ':bookingConfirmedLoaded',
};

const appendJavascriptSnippetToBody = (data, bookingId) => {
    logger.message(`APPENDING_JAVASCRIPT_SNIPPET ${bookingId}`);
    const oneFrontScript = document.createElement('script');
    oneFrontScript.innerText = data.javascriptSnippet;
    document.body.appendChild(oneFrontScript);
};

const buildJqueryParam = (value, param) => {
    return $('<input>', {
        value: value,
        name: param,
    });
};

const getUrlParameters = (url) => {
    const params = url
        ? url.slice(url.indexOf('?') + 1).split('&')
        : [];

    return Odigeo._.reduce(params, (result, value) => {
        if (value.indexOf('=') != -1) {
            const keyValue = value.split('=');
            result[keyValue[0]] = keyValue[1];
        }
        return result;
    }, {});
};

const createAndSubmitFormWithData = (data, chosenMethod, bookingId) => {
    Odigeo.Session.set('confirmInteractionNeededData', JSON.stringify(data));
    let target = {};

    if (chosenMethod === 'CREDITCARD') {
        const psd2Iframe = document.getElementById('iframe3ds');
        psd2Iframe.classList.remove('odf-hidden');
        target = {target: 'iframeUserInteractionNeeded'};
    }

    const $urlParams = Odigeo._.map(getUrlParameters(data.redirectUrl), buildJqueryParam);

    const $params = Odigeo._.map(data.parameters, buildJqueryParam);
    const formAttributes = Odigeo._.extend(target, {
        method: data.sendType,
        action: data.redirectUrl,
    });

    const msg = `Opening bank page DIRECTLY with parameters with bookingId ${bookingId} and params ${JSON.stringify({
        data,
        formAttributes,
        $params,
    })}`;
    logger.error({data, formAttributes, $params}, msg);

    $('<form>', formAttributes)
        .append($params)
        .append($urlParams)
        .appendTo($('body'))
        .submit();
};

const redirectInIframe = (data) => {
    const psd2Iframe = document.getElementById('iframe3ds');
    psd2Iframe.src = data.redirectUrl;
    psd2Iframe.classList.remove('odf-hidden');
};

const redirectAndShowWating = (data) => {
    if (data.htmlCode.match(/<html>/i)) {
        window.location.href = this.payment3dSecureURL;
    } else {
        if (!this.options.isDynpack) {
            Odigeo.UIElements.enhanceLoading($('.waiting_page'))
                .showLoading(['waiting_bottom', 'waiting_confirmation', 'waiting_bottom_gradient']);
        }

        $('#payment3ds').html(data.htmlCode);
    }
};

const clickButtonConfirmation = (data) => {
    try {
        $('html').html(data.htmlCode);
    } catch (error) {
        logger.error(error, 'avoid js errors that breaks js event flow');
    }
    const $buttonOK = $('input[name=DIRECTEBANKINGOPENREGULAR]');
    if ($buttonOK.length > 0) {
        $buttonOK.click();
    }
};

const handle3DSRedirect = (data, chosenMethod, bookingId) => {
    logger.error(`EMPTY_PARAMETERS_RETURNED_CHOSEN_METHOD_${chosenMethod}_${bookingId}`);
    if (chosenMethod === 'CREDITCARD') {
        redirectInIframe(data);
    } else {
        window.location.href = data.redirectUrl;
    }
};

function redirectToUrl(data, chosenMethod, bookingId) {
    if (!Odigeo._.isEmpty(data.redirectUrl)) {
        if (Odigeo._.isEmpty(data.parameters)) {
            handle3DSRedirect(data, chosenMethod, bookingId);
        } else {
            createAndSubmitFormWithData(data, chosenMethod, bookingId);
        }
    } else {
        if (this.model.get('chosenMethod') === 'SOFORT') {
            clickButtonConfirmation(data);
        } else {
            redirectAndShowWating.call(this, data);
        }
    }
}

export default $.extend(true, storeCreditCards.controller, {
    payment3dSecureURL: Odigeo.Settings.property('appContext') + '/secure/pay3dsecure',
    isPaymentMethodRetry: false,
    isRepricing: false,
    enhancedElementsList: [],
    bookingAlreadyDone: false,
    modelClass: Odigeo.Model.extend(Odigeo._.extend(require('./paymentmanager.model'), storeCreditCards.model)),
    viewClass: Odigeo.View.extend(Odigeo._.extend(require('./paymentmanager.view'), storeCreditCards.view)),

    init: function() {
        this.model
            .on('sync', this.view.updatePaymentOptions, this.view)
            .on('change:chosenMethod', this.view.updatePaymentMethod, this.view)
            .on('change:chosenCard', this.view.updateCreditCard, this.view)
            .on('cardChanges', this.view.showErrors, this.view)
            .on('change:response', this.checkResponse, this)
            .on('feeChanges', this.notifyFees, this)
            .on('change:user', onUserDataChanged, this);

        storeCreditCards.controller.initController.call(this);

        this.view
            .on('change:cardType', this.model.setCardType, this.model)
            .on('change:cardData', this.model.setCardData, this.model);

        this.view.cardFields = this.view.createFields(this.view.inputLabelCorrespondences);
    },

    fireResponseEvent(data) {
        const event = data.bookingstatus in responseEvents ? responseEvents[data.bookingstatus] : ':bookingErrorLoaded';
        Odigeo.trigger(this.id + event, data);
    },

    fireConfirmationReady(event, response, ...params) {
        Odigeo.trigger(this.id + event, this.pickResponseData(response, ...params));
    },

    pickResponseData(response, ...params) {
        return Odigeo._.chain(response)
            .pick(...params)
            .extend({
                'bookingstatus': response.bookingStatus,
            })
            .value();
    },

    handleConfirmationReadyUserInteraction(msg) {
        handler3ds.composePsd2Metric('3DS_TIME', '_FLIGHTS_', 'stopMetric');
        const isAccommodationPostBooking = Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'));
        const eventName = isAccommodationPostBooking ? ':confirmationAccommodationPostBookingReady' : ':confirmationReady';
        Odigeo.trigger(`${this.id}${eventName}`, msg);
    },

    handleConfirmationReady(response) {
        const shoppingCartDTO = response.shoppingCartDTO;
        dispatch({type: SET_SHOPPING_CART, entry: shoppingCartDTO});
        if (Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking')) && !response.errors) {
            this.fireConfirmationReady(':confirmationAccommodationPostBookingReady', response, 'myTrip',
                'flowErrors', 'analyticsEcommerce', 'tmsDatalayer', 'userInteractionNeededDTO');
        } else if (!response.errors) {
            this.fireConfirmationReady(':confirmationReady', response, 'repricing',
                'extensions', 'myTrip', 'membershipPerksDTO', 'flowErrors', 'userInteractionNeededDTO',
                'analyticsEcommerce', 'tmsDatalayer');
        }
    },

    checkResponse: function() {
        const response = this.model.get('response');
        this.handleConfirmationReady(response);
        this.fireResponseEvent(this.pickResponseData(response, 'repricing',
            'extensions', 'myTrip', 'membershipPerksDTO', 'flowErrors', 'userInteractionNeededDTO',
            'analyticsEcommerce', 'tmsDatalayer'));
    },

    notifyFees: function(data) {
        var feeData = {
            quantity: this.options.quantityOnePrice,
            numSegments: this.options.numSegments,
            numTravellers: this.options.numTravellers,
            priceLogic: data.priceLogic,
        };
        let currentMethod;
        if (data.chosenMethod === 'CREDITCARD') {
            if (!Odigeo._.isUndefined(data.chosenCard)) {
                Odigeo._.extend(feeData, {
                    totalFee: data.chosenCard.fee,
                    fee: data.chosenCard.fee / this.options.numTravellers,
                    name: data.chosenCard.name,
                    concept: data.chosenCard.code,
                    totalPax: this.options.numTravellers,
                    ccResolved: data.ccResolved,
                });
                currentMethod = data.chosenCard;
            }
        } else {
            var paymentOption = Odigeo._.find(data.paymentMethods, Odigeo._.matches({
                method: data.chosenMethod,
            }));

            if (!Odigeo._.isUndefined(paymentOption)) {
                Odigeo._.extend(feeData, {
                    fee: paymentOption.fee,
                    name: paymentOption.method,
                    concept: paymentOption.method,
                    ccResolved: true,
                });
                currentMethod = paymentOption;
            }
        }
        dispatch({type: SET_SELECTED_PAYMENT_METHOD, entry: currentMethod});

        if (data.priceLogic === 'MINIMUM_PURCHASE_PRICE_WITH_DISCOUNT') {
            Odigeo._.extend(feeData, {
                cheapestCCCode: data.presetCard.code,
                cheapestDiscount: data.presetCard.fee,
            });
        }

        Odigeo.trigger(this.id + ':feeChange', {
            id: this.id,
            data: feeData,
            type: 'card_fee',
        });
        this.view.cvvTypeChanged(feeData.concept === 'AX');
    },

    userInteractionNeeded: function(msg) {
        const data = msg.userInteractionNeededDTO;
        const bookingId = this.model.get('bookingId');

        Odigeo.Session.set('returnFromUserInteraction', true);
        if (!Odigeo._.isEmpty(data.javascriptSnippet)) {
            appendJavascriptSnippetToBody(data, bookingId);
        } else {
            redirectToUrl.call(this, data, this.model.get('chosenMethod'), bookingId);
        }
    },

    setCreditCardType: function(ccType, showCCDropdown, ccResolved) {
        this.model.changeCreditCard.call(this.model, ccType, ccResolved);
        this.model.set({showCCDropdown: showCCDropdown});
        this.model.get('cardFields').cvv2.setValidLength(this.model.getCvvLength(ccType));
    },

    userNotLogged: function() {
        this.view.toggleSaveDataCheck(true);
        this.model.set('selectedStorageCreditCard', null);
        this.model.setUserData(null);
        Odigeo._.delay(Odigeo._.bind(function() {
            this.view.restoreFieldsLocalStorage();
        }, this), 1000);
        this.model.setCreditCards(null);
        this.view.storeData.removeStorageOnNotSelected(this.view.$cachedSelectors.saveCardData, 'paymentData');
        if (Odigeo.AB.isMobileRevamp) {
            this.view.$cachedSelectors.root.removeClass('od-stored-cards-visible-revamp');
        } else {
            this.view.$cachedSelectors.root.removeClass('od-stored-cards-visible');
        }
    },

    userLogged: function(userDTO) {
        this.view.toggleSaveDataCheck(false);
        this.view.storeData.removeStorageOff(this.view.$cachedSelectors.saveCardData);
        this.model.setUserData(userDTO);
        Odigeo.trigger(this.id + ':getCreditCards');
    },

    isValid: function() {
        return this.model.isValid();
    },
    isIdealRequestValid: function() {
        return this.model.isIdealRequestValid();
    },

    getPaymentMethod: function() {
        return this.model.getPaymentMethod();
    },

    execute: function(fn) {
        var args = [].slice.call(arguments, 1);
        switch (fn) {
            case 'updatePaymentOptions':
                this.model.getPaymentOptions.apply(this.model, args);
                break;
            case 'onShowPsd2InfoMessage':
                this.view.onShowPsd2InfoMessage.apply(this.view, args);
                break;
            case 'updateFees':
                this.model.trigger('feeChanges', this.model.toJSON());
                break;
            case 'commit':
                this.model.commit.apply(this.model, args);
                break;
            case 'processCommitErrors':
                this.model.processCommitErrors.apply(this.model, args);
                break;
            case 'setEmptyCreditCard':
                this.model.setEmptyCreditCard.apply(this.model, args);
                break;
            case 'confirmationReady':
                this.handleConfirmationReady(this.model.get('response'));
                break;
            case 'confirmationReadyUserInteraction':
                this.handleConfirmationReadyUserInteraction(...args);
                break;
            case 'userInteractionNeeded':
                this.userInteractionNeeded.apply(this, args);
                break;
            case 'showNegativeFee':
                this.view.showNegativeFee.apply(this.view, args);
                break;
            case 'hideDialogs':
                this.view.hideDialogs();
                break;
            case 'paymentRetryDialog':
                this.view.showErrorPaymentRetryDialog.apply(this.view, args);
                break;
            case 'paymentRetry':
                this.view.showErrorPaymentRetryInline.apply(this.view, args);
                break;
            case 'fillForm':
                this.view.fillForm.apply(this.view, args);
                break;
            case 'enhancedElementList':
                this.view.enhancedElementsList.apply(this.view, args);
                break;
            case 'showCCDropdown':
                this.model.showCCDropdown.apply(this.model, args);
                break;
            case 'loadRepricingMessage':
                this.view.loadRepricingMessage.apply(this.view, args);
                break;
            case 'setManualPaymentRetry':
                this.view.setManualPaymentRetry(this.view, args);
                break;
            case 'setInvoiceRequestDTO':
                this.model.setInvoiceRequestDTO.apply(this.model, args);
                break;
            case 'setBookingUserComments':
                this.model.setBookingUserComments.apply(this.model, args);
                break;
            case 'setNewsletterSubscription':
                this.model.setNewsletterSubscription.apply(this.model, args);
                break;
            case 'setCreditCardType':
                this.setCreditCardType.apply(this, args);
                break;
            case 'userLogged':
                this.userLogged.apply(this, args);
                break;
            case 'userNotLogged':
                this.userNotLogged.apply(this);
                break;
            case 'setCreditCards':
                this.model.setCreditCards.apply(this.model, args);
                break;
            case 'cleanInputs':
                this.view.cleanInputs.apply(this.view, args);
                break;
            case 'cvvTypeChanged':
                this.view.cvvTypeChanged.apply(this.view, args);
                break;
            case 'creditCardTypeChanged':
                this.view.setCreditCardTypeIcon.apply(this.view, args);
                break;
            case 'changePaymentMethod':
                this.model.changePaymentMethod();
                break;
            case 'changePaymentMethodToOther':
                this.model.changePaymentMethodToOther();
                break;
            case 'removeCreditCardHintClosed':
                this.view.removeStoredCreditCardHintClosed.apply(this.view, args);
                break;
            case 'creditCardRemoved':
                this.view.removeStoredCreditCardSuccess.apply(this.view, args);
                break;
            case 'isStoredCardsAvailability':
                return this.model.isStoredCardsAvailability.apply(this.model, args);
            case 'blurAllInputs':
                return this.view.blurAllInputs.apply(this.view, args);
            case 'showFieldErrors':
                this.model.showFieldErrors.apply(this.model, args);
                break;
            case 'isStoredCardSelected':
                this.model.isStoredCardSelected.apply(this.model, args);
                break;
            case 'confirmationFlowErrors':
                return Odigeo._.get(this.model.get('response'), 'flowErrors', {});
        }
        return this;
    },
});
